module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-6.22886f61.mp3";